import React, { useState } from "react";
import { useEffect } from "react";
import "./CertificationListSection.scss";
import CertificationListComp from "./CertificationListComp";
import { Tab, Tabs } from "react-bootstrap";
import useLogin from "../../custom-hooks/useLogin";
import MyCertificationListComp from "./MyCertificationListComp";
import { useSelector } from "react-redux";
import _ from "lodash";

export default function CertificationListSection() {
  const { isLoggedIn } = useLogin();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let providerId = "";
  let allPartners="";
  let providerName = "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    providerId = paramsReq.provider_id;
    allPartners = paramsReq?.allPartners;
    providerName = paramsReq?.provider_name;
  }

  const authBroker = useSelector((state) => state.auth.authBroker);

  const [key, setKey] = useState("certi");
  
  useEffect(() => {
    window.scrollTo(0, 0);
 
  }, []);

  const renderCertificates = ()=>{
    if(key==="certi"){
      return <CertificationListComp />
    }else {
      return <MyCertificationListComp />
    }
  }

  const renderTitle = () => {
    return (
    <div dangerouslySetInnerHTML={{__html: allPartners ? `Certifications from ${authBroker?.payload?.user?.config?.partner_menu_text !== undefined && !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)?
      authBroker?.payload?.user?.config?.partner_menu_text?.toLowerCase():
      "Learning Partners"}`: providerName ? `Certifications from ${providerName}` : "Certifications"}}></div>
    )
}

  return (
    <>
      {/* <Loader start={isLoading} /> */}
      <div className="contsection">
      <nav>
      <div className="nav nav-tabs" id="nav-tab" role="tablist">
        
        <Tabs
          underline
          activeKey={key}
          onSelect={(k) => {
            // setIsFetching(true)
            console.log("selectKey: ", k);
           if(allPartners || providerName) {

           } else { 

           setKey(k);
           }
            if (k === "certi") {
              
            } else {
              
            }
          }}
        >
          <Tab eventKey={"certi"} title={renderTitle()}></Tab>
          {isLoggedIn && !providerId && !allPartners && (
            <Tab eventKey={"myCerti"} title="My certifications"></Tab>
          )}
        </Tabs>
      </div>
    </nav>

        {renderCertificates()}
      </div>
    </>
  );
}
